import { useState, useEffect } from 'react'
import { Chart } from 'primereact/chart'
import { useAppSelector } from '../../../store/hooks'
import { chartColorVariants, type ChartDataProps } from './chartsUtil'
import ChartContainer from './ChartContainer'

interface PolarChartProps {
    data?: ChartDataProps
}

const PolarChart = ({ data }: PolarChartProps) => {
    const theme = useAppSelector((state) => state.theme.theme)

    const [chartData, setChartData] = useState<ChartDataProps | Record<string, unknown> | undefined>({})
    const [chartOptions, setChartOptions] = useState<Record<string, unknown>>({})

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement)
        const textColor = documentStyle.getPropertyValue(
            theme === 'dark' ? '--bs-white' : '--bs-black'
        )
        const surfaceBorder =
            documentStyle.getPropertyValue('--bs-border-color')

        const options = {
            maintainAspectRatio: false,
            responsive: true,
            layout: {
                padding: 20,
            },
            plugins: {
                legend: {
                    labels: {
                        color: textColor,
                    },
                },
            },
            scales: {
                r: {
                    grid: {
                        color: surfaceBorder,
                    },
                },
            },
        }

        const finalisedChartData = data
        const ds = data?.datasets?.[0] ?? {}
        const dsData = (ds['data'] as unknown[]) ?? []

        ds['borderColor'] = []
        ds['backgroundColor'] = []

        const borderColors: string[] = []
        const backgroundColors: string[] = []

        for (let i = 0; i < dsData.length; i++) {
            const colorVariant = chartColorVariants[i]

            if (colorVariant) {
                borderColors.push(
                    documentStyle.getPropertyValue('--bs-' + colorVariant)
                )
                backgroundColors.push(
                    documentStyle.getPropertyValue('--bs-' + colorVariant) +
                        '80'
                )
            }
        }

        ds['borderColor'] = borderColors
        ds['backgroundColor'] = backgroundColors

        setChartData(finalisedChartData)
        setChartOptions(options)
    }, [theme, data])

    return (
        <ChartContainer style={{ height: '100%', minHeight: 260 }} className="w-100 h-100">
            <Chart
                type="polarArea"
                data={chartData}
                options={chartOptions}
                className="w-100 h-100 d-block"
            />
        </ChartContainer>
    )
}

export default PolarChart
